var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"position-relative",attrs:{"id":"container"}},[_c('v-stage',{ref:"stage",staticClass:"hatch-grid",attrs:{"config":_vm.configKonva}},[_c('v-layer',[_vm._l((_vm.getXLabels()),function(value,index){return _c('v-text',{key:`x-label-${index}`,attrs:{"config":_vm.getXLabelConfig(value, index)}})}),_vm._l((_vm.getYLabels()),function(value,index){return _c('v-text',{key:`y-label-${index}`,attrs:{"config":_vm.getYLabelConfig(value, index)}})}),_vm._l((_vm.getYLabels()),function(value,index){return _c('v-text',{key:`y-label-left-${index}`,attrs:{"config":_vm.getYLabelConfigLeft(value, index)}})}),_vm._l((_vm.containers),function(container,containerIndex){return _c('v-group',{key:container.id,attrs:{"config":{ x: 0, y: 0 }}},[_c('v-rect',{attrs:{"config":container}}),(
            _vm.vesselBayType == 2 &&
              container.stowageInstructionDetailId > 0 &&
              container.isInBay &&
              container.stowageInstructionIs4045Foot
          )?_c('v-text',{attrs:{"config":{
            ..._vm.textConfig,
            text: '+',
            x: container.x + (_vm.CELL_WIDTH / 2 - 2),
            y: container.y + (_vm.CELL_WIDTH / 2 - 4),
            listening: false,
            onmouseover: () => {
              this.document.body.style.cursor = 'not-allowed';
            },
          }}}):_vm._e()],1)})],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }